import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Accordion } from "../../../../components/Accordion";
import { DataGrid } from "../../../ui/components/DataGrid";
import { FunctionViewField } from "../../../ui/components/viewField/FunctionViewField";
import { ListContainer } from "../../../ui/containers/ListContainer";
import { TCompanyWithRole } from "../../../company/models";
import { changeNotificationEnabled } from "../../../company/network";

export const UserCompaniesBlock: FC<{
  companies: { items: TCompanyWithRole[] };
  userId: string;
}> = ({ companies, userId }) => {
  const [save, setSave] = useState<string>("");

  useEffect(() => {
    if (save) {
      const timer = setTimeout(() => {
        setSave("");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [save]);

  return (
    <Accordion disableGutters>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='panel1a-content'
        id='panel1a-header'
      >
        <Typography
          variant='h6'
          sx={{
            fontWeight: "800",
            fontSize: "20px",
            lineHeight: "28px",
            letterSpacing: "0.5px",
            color: "#1C1F21",
          }}
        >
          Companies
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <ListContainer data={companies?.items}>
          <DataGrid>
            <FunctionViewField
              label='Name'
              source='name'
              render={(record: TCompanyWithRole) => (
                <Box>
                  <Typography variant='h6'>{record.name}</Typography>
                </Box>
              )}
            />
            <FunctionViewField
              label='ID'
              source='id'
              render={(record: TCompanyWithRole) => (
                <Box>
                  <Typography variant='body2'>{record.id}</Typography>
                </Box>
              )}
            />
            <FunctionViewField
              label='Role'
              source='role'
              render={(record: TCompanyWithRole) => (
                <Box>
                  <Typography
                    sx={{ textTransform: "capitalize" }}
                    variant='body2'
                  >
                    {record.role}
                  </Typography>
                </Box>
              )}
            />
            <FunctionViewField
              label='Notifications Off/On'
              source='notification'
              render={(record: TCompanyWithRole) => {
                return (
                  <Stack direction='row'>
                    <Switch
                      defaultChecked={record.emailNotificationEnabled}
                      onChange={async () => {
                        setSave("");
                        await changeNotificationEnabled(record.id, userId);
                        setSave(record.id);
                      }}
                    />
                    {save === record.id ? (
                      <Alert sx={{ padding: "0 16px" }} severity='success'>
                        Saved
                      </Alert>
                    ) : (
                      <Stack sx={{ width: "105px" }} />
                    )}
                  </Stack>
                );
              }}
            />
          </DataGrid>
        </ListContainer>
      </AccordionDetails>
    </Accordion>
  );
};
